import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, CardSubtitle, Input, Label, Button, Form, Alert, Toast, ToastHeader, ToastBody,   Modal,
  ModalHeader,
  ModalBody,
 } from "reactstrap";
import { get, post, put } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import UploadImage from "common/uploadImage";
import { COLLHUB_SEARCH, SHOW_COLLHUB, ADD_COLLHUB, UPDATE_COLLHUB, REMOVE_COLLHUB, ADDRESS_TYPE, DELIVERY_TYPE_SEARCH, COUNTRIES_SEARCH, DRIVERS_SEARCH, SHIPMENT_TYPES_SEARCH,
     VEHICLE_CATEGORY_SEARCH, STATUS_SEARCH, USERS_SEARCH, PARTNERS_SEARCH, CITIES_SEARCH, DISTRICTS_SEARCH,
    ADD_ADDRESS, SUBDISTRICTS_SEARCH, UPDATE_ADDRESS, PARTNERS_BRANCH_SEARCH, LANGUAGES_SEARCH, PARTNERS_BRANCH_LIST, ADDRESS_LIST   } from "helpers/api_endpoints";
import Select from "react-select";
import MapComponent from "../../components/Common/MapSelect"
import AddressComponent from "../../components/Common/AddressSelect"
import ConfirmModal from "components/Common/ConfirmModal";
import AddressForm from "components/Common/AddressForm";


//meta title
document.title = "Add CollectionHub";

const AddCollHub = () => {


    const params = useParams();
    const [id, setId] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    //
    const [marker, setMarker] = useState({lat:24.712186535213522,lng:55.11976906855254});
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [isAddress1ModalOpen, setIsAddress1ModalOpen] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [address, setAddress] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [building, setBuilding] = useState(null);
    const [phone, setPhone] = useState(null);
    const [street, setStreet] = useState(null);
    const [flatNo, setFlatNo] = useState(null);
    const [cityId, setCityId] = useState(0);
    const [districtId, setDistrictId] = useState(0);
    const [subDistrictId, setSubDistrictId] = useState(0);
    const [title, setTitle] = useState('');
    const [countryId, setCountryId] = useState('');
    const [addressId, setAddressId] = useState('');

    //
    const [userId, setUserId] = useState(0);


    const [partnerBranchId, setPartnerBranchId] = useState(0);
    const [partnerId, setPartnerId] = useState(0);
    const [handOverTime, setHandOverTime] = useState(0);
    const [currentDistance, setCurrentDistance] = useState(0);
    const [currentDuration, setCurrentDuration] = useState(0);
    const [minThreshold, setMinThreshold] = useState(1);
    const [name, setName] = useState('{"title":[{"1":""}]}');
    const [named, setNamed] = useState('');
    const [driverId, setDriverId] = useState(null);
    const [driverName, setDriverName] = useState('');



    
    const [area, setArea] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [partnerBranches, setPartnerBranches] = useState([]);
    const [cpartnerBranches, setCPartnerBranches] = useState([]);
    const [partners, setPartners] = useState([]);
    const [users, setUsers] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [subDistricts, setSubDistricts] = useState([]);
    const [countries, setCountries] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [statues, setStatues] = useState([]);
    const [filters, setFilters] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const [update, setUpdate] = useState(0);
    const [image, setImage] = useState('');
    const [msgHeader, setMsgHeader] = useState('Warning');
    const [msgBody, setMsgBody] = useState('');
    const [toastShow, setToastShow] = useState(false);
    const [loading, setLoading] = useState(true);


    const navigate = useNavigate();

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                // navigate('/collhub');
            })
    }, []);

    useEffect(() => {
        console.log('name', name)
    }, [name]);


    const loadData = () => {
        if(params.id != undefined) {
            get(`${SHOW_COLLHUB}/${params.id}`)
                .then(response => {
                    const resData = response.data;
                    setId(params.id);
                    setPartnerBranchId(resData.partnerBranchId);
                    setPartnerId(resData.partnerBranch.partnerId);
                    // setUserId(resData.userId);
                    setName(resData.name==''?'{"title":[{"1":"a"}]}':JSON.stringify(resData.named));
                    setNamed(resData.named);
                    setDriverId(resData.driverId);
                    setAddressId(resData.addressId);
                    setHandOverTime(resData.handOverTime);
                    setMinThreshold(resData.minThreshold);
                    setArea(resData.serviceArea.map(el => {return {value: el.id, label: el.title, data: el}}));
                    setLoading(false);
                })
                .catch(error => {
                    console.log(error);
                    // navigate('/orders');
                })
        }
        getAddresses();
    }

    const getAddresses = () => {
        get(ADDRESS_LIST).then(response => {
            const formattedAddresses = response.data.map(el => ({
                value: el.id,
                label: `${el.title} ${el.country?.name} ${el.city?.name} ${el.district?.name} ${el.subDistrict?.name} ${el.street} ${el.additional}`,
                data: el // include the full address object
            }))
            
            setAddresses(formattedAddresses)
            
        })
    }

    useEffect(() => {
        loadData();
    }, [loading]);

    // useEffect(() => {
    //     if(parseInt(packagesNo) <1 || parseInt(packagesNo) >3);
    //         setPackagesNo(1);
    // }, [packagesNo]);

    useEffect(() => {
        setCities(cities.filter(el => {
           return el.countryId == countryId;
        }))
    }, [countryId]);


    useEffect(() => {
        setDistricts(districts.filter(el => {
           return el.cityId == cityId;
        }))
    }, [cityId]);


    useEffect(() => {
        setSubDistricts(subDistricts.filter(el => {
           return el.districtId == districtId;
        }))
    }, [districtId]);


    useEffect(() => {
        setLatitude(marker.lat);
        setLongitude(marker.lng);
    }, [marker]);

    useEffect(() => {
        setPartnerBranches(cpartnerBranches.filter(el => {
           return el.partnerId == partnerId;
        }))
    }, [partnerId]);


    useEffect(() => {
        post(ADDRESS_TYPE+'/0')
            .then(response => {
                const temp = response.data.map(el=>{
                    return {value:el.id,label:el.title}
                });
                setAddressesFrom(temp);
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(CITIES_SEARCH)
            .then(response => {
                setCities(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated, countryId:el.countryId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(DISTRICTS_SEARCH)
            .then(response => {
                setDistricts(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated, cityId:el.cityId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(SUBDISTRICTS_SEARCH)
            .then(response => {
                setSubDistricts(response.data.map(el=>{
                    return {value:el.id, label:el.nameTranslated, districtId:el.districtId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(PARTNERS_SEARCH)
            .then(response => {
                setPartners(response.data.map(el=>{
                    return {value:el.id,label:el.name}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        get(PARTNERS_BRANCH_LIST)
            .then(response => {
                setPartnerBranches(response.data.map(el=>{
                    return {value:el.id, label:el.name, partnerId:el.partnerId}
                }));
                setCPartnerBranches(response.data.map(el=>{
                    return {value:el.id, label:el.name, partnerId:el.partnerId}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            });
        post(DRIVERS_SEARCH, {driverTypeId: 4})
            .then(response => {
                setDrivers(response.data.map(el=>{
                    return {value:el.id,label:el.name}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
        post(COUNTRIES_SEARCH)
            .then(response => {
                setCountries(response.data.map(el=>{
                    return {value:el.id,label:el.nameTranslated}
                }));
            })
            .catch(error => {
                console.log('Loading Failed');
            })
    }, []);

    const handleName = (languageId,value) => {
        if(!named.title){
            setNamed({"title":[{"1":value}]});
            return;  
        } 
        const ln = named.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            named.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(named));             
    }


    const handleSubmit = () => {
        if(area.length==0)
        {
            seterrorMsg('You must provide at lease 1 address');
            setTimeout(() => {
                seterrorMsg('');
            }, 4500);
            return false;
        }
        if(id != '')
        {
            put(UPDATE_COLLHUB, {id, name, addressId:addressId, driverId, handOverTime, minThreshold, partnerBranchId, area:area.map(el => el.data.id)})
            .then(response => {
                if (response.code == 200) {
                    navigate('/collhub', { state: { successMsg: 'Updated SuccessFully' } });
                }    
            })
        }
        else
        {
            post(ADD_COLLHUB, {name, addressId:addressId, driverId, handOverTime, minThreshold, partnerBranchId, area:area.map(el => el.data.id)})
            .then(response => {
                if (response.code == 201) {
                    navigate('/collhub', { state: { successMsg: 'Added SuccessFully' } });
                }    
            })
        }
    }

    const handleConfirmYes = () => {
        setCurrentStatusId(newCurrentStatusId);
        setShowConfirmModal(false);
    }

    const handleFilter = (type, value, key='') => {
        const filtvalues = {};
        const regx1 = /^(50|52|54|55|56|58)\d{7}$/
        const regx2 = /^(02|03|04|05|06|07|08)\d{7}$/
        console.log('p', type, value)
        const newArea = [...area];
        if (value) {
            switch (type) {
                case 'countryId':
                    setCountryId(value);
                    break;
                case 'name':
                    setName(value);
                    break;
                case 'driverId':
                    setDriverId(value);
                    break;
                case 'addressId':
                    setAddressId(value);
                    break;
                case 'countryId':
                    setCountryId(value);
                    break;
                case 'partnerBranchId':
                    setPartnerBranchId(value);
                    break;
                case 'partnerId':
                    setPartnerId(value);
                    break;
                case 'handOverTime':
                    setHandOverTime(value);
                    break;
                case 'minThreshold':
                    setMinThreshold(value);
                    break;
                case 'title':
                    newArea[key].title = value;
                    setArea(newArea);
                    break;
                case 'countryId':
                    newArea[key].countryId = value;
                    setArea(newArea);
                    break;
                case 'cityId':
                    newArea[key].cityId = value;
                    setArea(newArea);
                    break;
                case 'districtId':
                    newArea[key].districtId = value;
                    setArea(newArea);
                    break;
                case 'subDistrictId':
                    newArea[key].subDistrictId = value;
                    setArea(newArea);
                    break;
                case 'latitude':
                    newArea[key].latitude = value;
                    setArea(newArea);
                    break;
                case 'longitude':
                    newArea[key].longitude = value;
                    setArea(newArea);
                    break;
                case 'building':
                    newArea[key].building = value;
                    setArea(newArea);
                    break;
                case 'street':
                    newArea[key].street = value;
                    setArea(newArea);
                    break;
                case 'flatNo':
                    newArea[key].flatNo = value;
                    setArea(newArea);
                    break;
                case 'phone':
                    if(ev=='') break;
                    if(regx1.test(value) || regx2.test(value))
                    {
                        setPhone(value);
                    }
                    else
                    {
                        setToastShow(true);
                        setTimeout(function(){setToastShow(false)},2400);    
                        setMsgBody('Drop Location Phone number not correct')
                    }
                    newArea[key].phone = value;
                    setArea(newArea);
                    break;
                case 'coverageArea':
                    
                    const aArea = [];
                    value.some(el => {
                        aArea.push(el);
                    })
                    setArea(aArea);
                    break;
                default:
                    break;
            }
        }
        // setFilters(filtvalues);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <ConfirmModal
                    show={showConfirmModal}
                    onYesClick={handleConfirmYes}
                    onNoClick={() => setShowConfirmModal(false)}
                />
                {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                <Toast isOpen={toastShow} fade={true} className="position-fixed end-0 p-3" style={{"bottom":"3px", "z-index":"111", "margin":"10px"}}>
                    <ToastHeader>
                        {msgHeader}
                    </ToastHeader>
                    <ToastBody>
                        {msgBody}
                    </ToastBody>
                </Toast>
                <div className="container-fluid">
                    <Breadcrumbs title="Items" breadcrumbItem={params.id==undefined?"Add CollectionHub":"Edit CollectionHub"} />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}

                                            <CardBody>
                                            <Row>
                                            {languages.map((language, index) => (
                                                <div className="form-group col-md-3 mt-2" key={index}>
                                                    <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                    <Input
                                                        name="name"
                                                        value={named.title?named.title.find(el => {return el[language.id]})?named.title.find(el => {return el[language.id]})[language.id]:'':''}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => handleName(language.id,e.target.value)}
                                                        required={language.id==1||language.id==2?true:false} ></Input>
                                                    <Input type="hidden" name="id"></Input>
                                                </div>
                                                ))
                                            }
                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Handover Time</Trans></Label>
                                                    <Input
                                                    name="title"
                                                    value={handOverTime}
                                                    className="form-control"
                                                    placeholder="Enter time "
                                                    type="number"
                                                    required
                                                    onChange={(e) => handleFilter('handOverTime', e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Minimum threshold</Trans></Label>
                                                    <Input
                                                    name="title"
                                                    value={minThreshold}
                                                    className="form-control"
                                                    placeholder="Enter threshould "
                                                    type="number"
                                                    min={1}
                                                    required
                                                    onChange={(e) => handleFilter('minThreshold', e.target.value)}
                                                    ></Input>
                                                </div>
                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Driver</Trans></Label>
                                                    <Select
                                                    name="driverId"
                                                    value={drivers.filter(option => {return driverId==option.value})}
                                                    options={drivers} 
                                                    className="form-control select2"
                                                    required
                                                    onChange={(e) => handleFilter('driverId', e.value)}
                                                    />
                                                </div>
                                                <div className="form-group col-md-4 mt-2" style={{boxShadow:"0px 1px 2px 0px orange", padding:"3px"}}>
                                                    <Row>
                                                    <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Partner </Trans></Label>
                                                        <Select
                                                        name="partnerId"
                                                        options={partners} 
                                                        value={partners.filter(option => {return partnerId==option.value})}
                                                        className="form-control select2"
                                                        onChange={(e) => handleFilter('partnerId', e.value)}
                                                        />
                                                    </div>
                                                    <div className="form-group col-md-6 mt-2">
                                                        <Label className="form-label"><Trans>Partner Branch</Trans></Label>
                                                        <Select
                                                        name="partnerBranchId"
                                                        options={partnerBranches} 
                                                        value={partnerBranches.filter(option => {return partnerBranchId==option.value})}
                                                        className="form-control select2"
                                                        required
                                                        onChange={(e) => handleFilter('partnerBranchId', e.value)}
                                                        />
                                                    </div>
                                                    </Row>
                                                </div>

                                            </Row>
                                            <Row>
                                                <Label className="form-label"><Trans>Address </Trans></Label>
                                                <div className="mb-3">
                                                    <Select
                                                    name="addressId"
                                                    options={addresses}
                                                    value={addresses.filter(address =>
                                                        address.value==addressId
                                                    
                                                    )}
                                                    onChange={(e) => handleFilter('addressId', e.value)}
                                                    closeMenuOnSelect={false}
                                                    placeholder="Select addresses for ..."
                                                    />
                                                    <Button onClick={() => setIsAddress1ModalOpen(true)} color="danger">Create Address +</Button>
                                                </div>
                                            </Row>
                                            </CardBody>

                                            <CardBody >
                                            <Row>
                                                <h4 className="form-label"><Trans>Coverage Area</Trans></h4>
                                                <div className="mb-3">
                                                    <Select
                                                    isMulti
                                                    name="coverageAddresses"
                                                    options={addresses}
                                                    value={addresses.filter(option =>{
                                                        return area.some(
                                                        addr => addr.value === option.value
                                                        )
                                                    }
                                                    )}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    onChange={(e) => handleFilter('coverageArea', e)}
                                                    closeMenuOnSelect={false}
                                                    placeholder="Select addresses for ..."
                                                    />
                                                    <Button onClick={() => setIsAddressModalOpen(true)} color="danger">Create Address +</Button>
                                                </div>
                                            </Row>
                                            </CardBody>

                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            /*Do not delete */
                        }
                        {/* <Card>
                            <CardBody>
                                {items.map((item,index) => (
                                    <div data-test={item.itemId} key={index}>
                                        <OrderDet type="item" item={item} />
                                    </div>

                                ))}
                                <div className="mt-4">
                                    <Button type="button" color="info" onClick={ e => {e.preventDefault()
                                                                                items.push({itemId:0,quantity:0,price:0,item:{}})
                                                                                setUpdate(Math.random())}}>
                                        <Trans>Add</Trans>
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                {services.map((service,index) => (
                                    <div key={index}>
                                        <OrderDet type="service" item={service} />
                                    </div>

                                ))}
                                <div className="mt-4">
                                    <Button type="button" color="info" onClick={ e => {e.preventDefault()
                                                                                services.push({serviceId:0,quantity:0,price:0,service:{}})
                                                                                setUpdate(Math.random())}}>
                                        <Trans>Add</Trans>
                                    </Button>
                                </div>
                            </CardBody>
                        </Card> */}
                        <div className="mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                        </div>
                    </Form>
                    <Modal isOpen={isAddressModalOpen} toggle={() => setIsAddressModalOpen(!isAddressModalOpen)}>
                    <ModalHeader toggle={() => setIsAddressModalOpen(false)}>
                        Create New Address
                    </ModalHeader>
                    <ModalBody>
                        <AddressForm  mode={2}
                        onSuccess={(createdAddress) => {
                            getAddresses();
                            const newArea = [...area];
                            newArea.push({value:createdAddress.id, label:createdAddress.title, data:createdAddress})
                            setArea(newArea);
                            setIsAddressModalOpen(false);
                        }}
                        onCancel={() => setIsAddressModalOpen(false)}
                        />
                    </ModalBody>
                    </Modal>

                    <Modal isOpen={isAddress1ModalOpen} toggle={() => setIsAddressModalOpen(!isAddress1ModalOpen)}>
                    <ModalHeader toggle={() => setIsAddress1ModalOpen(false)}>
                        Create New Address
                    </ModalHeader>
                    <ModalBody>
                        <AddressForm mode={1} 
                        onSuccess={(createdAddress) => {
                            getAddresses();
                            setAddressId(createdAddress.id);
                            setIsAddress1ModalOpen(false);
                        }}
                        onCancel={() => setIsAddress1ModalOpen(false)}
                        />
                    </ModalBody>
                    </Modal>

                </div>
            </div>
        </React.Fragment>
    )
}

export default AddCollHub
